import { render } from "./StudentCreditsView.vue?vue&type=template&id=68a0ba3d&scoped=true"
import script from "./StudentCreditsView.vue?vue&type=script&lang=js"
export * from "./StudentCreditsView.vue?vue&type=script&lang=js"

import "./StudentCreditsView.vue?vue&type=style&index=0&id=68a0ba3d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a0ba3d"]])

export default __exports__